import * as zod from 'zod';

export const MiraiControllerCommand = zod.object({
  kind: zod.literal('MiraiControllerCommand'),
  skillId: zod.number(),
});

export type MiraiControllerCommand = zod.infer<typeof MiraiControllerCommand>;
